import * as React from 'react';

import { Button } from '@/ui/button';
import { cn } from '@/utils';

import BookIcon from '../../assets/new_course.svg';

import { SchoolCurriculumDrawer } from './school-curriculum-drawer';

export const SchoolCurriculumCard = React.forwardRef<HTMLDivElement>(
  (_, ref) => {
    const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);

    const handleClick = React.useCallback(() => {
      setIsDrawerOpen(true);
    }, []);

    const handleCloseDrawer = React.useCallback(() => {
      setIsDrawerOpen(false);
    }, []);

    return (
      <>
        <div
          ref={ref}
          className={cn(
            'bg-white/60 rounded-[14px] p-4',
            'flex items-center gap-4',
            'transition-all duration-200',
            'hover:shadow-lg'
          )}
        >
          {/* Icon Container */}
          <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center">
            <img src={BookIcon} alt="book" className="w-12 h-12" />
          </div>

          {/* Content */}
          <div className="flex-1">
            <h3 className="text-sm font-semibold text-gray-900">
              New Course Unlocked
            </h3>
            <p className="text-xs text-gray-600 mt-0.5">
              Enjoy access to a tailored course
            </p>
          </div>

          {/* Action Button */}
          <Button
            variant="outline"
            size="sm"
            onClick={handleClick}
            className="flex-shrink-0"
          >
            View
          </Button>
        </div>

        {/* Drawer */}
        <SchoolCurriculumDrawer
          isOpen={isDrawerOpen}
          onClose={handleCloseDrawer}
        />
      </>
    );
  }
);

SchoolCurriculumCard.displayName = 'SchoolCurriculumCard';
